export default __webpack_public_path__ + "a5da7d2da88192c53f52fe3e6891b9aa4b551174986cf2889f6ac7fc32baaf5d.png";